import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(4),
    paddingTop: theme.spacing(4),
  },
  title: {
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  appbar: {
    boxShadow: 'unset',
  },
  tabs: {
    backgroundColor: '#FAFAFA',
  },
  tab: {
    color: theme.palette.primary.light,
    fontFamily: theme.typography.h1.fontFamily,
    fontSize: 12,
  },
  selected: {
    fontWeight: 'bold',
  },
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    backgroundColor: '#b7c4b7',
  },
}));
